export default __webpack_public_path__ + "static/mission-cube-bb77d4eb8dc9c7a816f5393658cf38be.png";